import axios from 'axios'
import store from '../store'
import router from '../router'
import { API_BASE_URL } from '@/config/api'

// Configuration de base d'Axios - Ajouter /api à la baseURL
const api = axios.create({
  baseURL: `${API_BASE_URL}/api`,
  timeout: 15000,
  headers: {
    'Content-Type': 'application/json'
  }
})

console.log('📡 Axios configured with baseURL:', `${API_BASE_URL}/api`)

// Intercepteur de requête pour ajouter le token d'authentification
api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('token')
    if (token) {
      config.headers.Authorization = `Bearer ${token}`
    }
    return config
  },
  (error) => {
    return Promise.reject(error)
  }
)

// Intercepteur de réponse pour gérer les erreurs globalement
api.interceptors.response.use(
  (response) => {
    return response
  },
  (error) => {
    // Gestion des erreurs d'authentification
    if (error.response?.status === 401) {
      // Token expiré ou invalide
      localStorage.removeItem('token')
      store.dispatch('auth/logout')
      
      // Rediriger vers la page de connexion si pas déjà sur cette page
      if (router.currentRoute.value.name !== 'Login') {
        router.push('/login')
      }
      
      // Afficher une notification
      store.dispatch('notifications/showError', 'Session expirée. Veuillez vous reconnecter.')
    }
    
    // Gestion des erreurs de permissions - masquée pour éviter les notifications intempestives
    // else if (error.response?.status === 403) {
    //   store.dispatch('notifications/showError', 'Vous n\'avez pas les permissions nécessaires pour cette action.')
    // }
    
    // Gestion des erreurs serveur
    else if (error.response?.status >= 500) {
      store.dispatch('notifications/showError', 'Erreur serveur. Veuillez réessayer plus tard.')
    }
    
    // Gestion des erreurs réseau
    else if (error.code === 'NETWORK_ERROR' || error.message === 'Network Error') {
      store.dispatch('notifications/showError', 'Erreur de connexion. Vérifiez votre connexion internet.')
    }
    
    // Gestion du timeout
    else if (error.code === 'ECONNABORTED') {
      store.dispatch('notifications/showError', 'La requête a pris trop de temps. Veuillez réessayer.')
    }
    
    return Promise.reject(error)
  }
)

export default api
